export enum OrderExpirationType {
    GoodTilCancel = 1,
    GoodTilDate,
    Day,
    FillOrKill,
    ImmediateOrCancel
}

export const AllOrderExpirationTypes: OrderExpirationType[] = [
    OrderExpirationType.GoodTilCancel,
    OrderExpirationType.GoodTilDate,
    OrderExpirationType.Day,
    OrderExpirationType.FillOrKill,
    OrderExpirationType.ImmediateOrCancel
];

export function getOrderExpirationTypeName(orderExpirationType: OrderExpirationType): string {
    switch (orderExpirationType) {
        case OrderExpirationType.GoodTilCancel:
            return "Good Till Cancel";
        case OrderExpirationType.GoodTilDate:
            return "Good Till Date";
        case OrderExpirationType.Day:
            return "Day";
        case OrderExpirationType.FillOrKill:
            return "Fill Or Kill";
        case OrderExpirationType.ImmediateOrCancel:
            return "Immediate Or Cancel";
        default:
            return "";
    }
}